<template>
  <div
    class="odd:bg-gray-100 border rounded px-4 flex-1 text-sm"
    :class="[focus ? 'border-gray-700' : 'border-gray-200']"
  >
    <div class="flex -mx-4 justify-between items-center">
      <div class="flex-1 p-4">
        <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
          <div class="flex-1 px-4 space-y-2">
            <h5 class="font-normal text-sm">
              {{ productionOrder.name || 'no title' }}
            </h5>
          </div>
          <div class="w-48 px-4">
            {{ project ? project.name : '---' }}
          </div>
          <div class="w-48 px-4">
            {{ provider ? provider.name : 'provider not available' }}
          </div>
          <div class="w-32 px-4 capitalize">
            <template v-if="productionOrderItem">
              {{ productionOrderItem.status || 'Not set' }}
            </template>
            <template v-else> Not set </template>
          </div>
          <div class="w-32 px-4">
            {{ productionOrder.deliveryAt || '---' }}
          </div>
        </div>
      </div>

      <div class="flex-none pr-4">
        <button
          :disabled="disabled || !productionOrderItem"
          class="w-10 h-10 px-4 py-2 rounded text-blue-600 hover:bg-blue-600 hover:text-white focus:outline-none disabled:text-gray-400 disabled:bg-transparent"
          @click="$emit('production-order-item:view', productionOrderItem.uuid)"
        >
          <FontAwesomeIcon icon="chevron-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    productionOrder: { type: Object, required: true },
    disabled: Boolean,
    focus: Boolean,
  },

  computed: {
    ...mapState('entities', {
      provider({ accountRelations }) {
        return accountRelations.byId[this.productionOrder.provider] || null;
      },
      productionOrderItem({ orderItems }) {
        if (!this.productionOrder.orderItems) return undefined;
        if (!this.productionOrder.orderItems.length) return undefined;

        return orderItems.byId[this.productionOrder.orderItems[0]];
      },
      project({ projects }) {
        if (!this.productionOrder.projectUuid) {
          return undefined;
        }

        return projects.byId[this.productionOrder.projectUuid];
      },
    }),
  },
};
</script>
